/**
 * Serialized node types that are content on their own, without holding
 * any text: an image is the whole point of a report made of one image,
 * and a table the user took the trouble to insert is worth keeping even
 * before a single cell is filled in.
 */
const CONTENT_NODE_TYPES = new Set(["image", "table"]);

/**
 * Tells whether a serialized rich text editor state holds any content.
 *
 * The whole tree is walked, because content is not necessarily in the
 * first block: a report starting with an empty line keeps its first
 * paragraph childless and its text in the next one.
 *
 * A node counts as content when its text is not blank once trimmed, or
 * when it is a standalone content node. This is the single rule the
 * editor itself applies when it decides to store null instead of a
 * state, so any state that reaches the backend answers true here.
 * @param {object|null|undefined} editorState - Serialized editor state.
 * @returns {boolean}
 */
export const hasEditorContent = (editorState) => {
    const nodeHasContent = (node) =>
        CONTENT_NODE_TYPES.has(node?.type) ||
        Boolean(node?.text?.trim()) ||
        Boolean(node?.children?.some(nodeHasContent));

    return nodeHasContent(editorState?.root);
};
